import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import themes from '@nautilusjs/themes'
import { DashboardsProvider } from '@mandiant-mfe/dashboards'
import { EodDrawerProvider } from '@nautilusjs/eod'
import { UpgradeContextProvider } from '@maui/freemium'
import { MauiProvider } from '@maui-mf/root'

import App from './App'
import GlobalTheme from './GlobalTheme'
import { AuthContextProvider } from './AuthContext'
import store from './store'
import env from './env'
import { authenticatedFetch } from '@maui-mf/common-auth'
import { MATIApiProvider } from './providers'

import './index.css'

export const withProviders = Component => {
  const AppProviders = () => (
    <MauiProvider>
      <BrowserRouter>
        <Provider store={store}>
          <AuthContextProvider>
            <MATIApiProvider>
              <DashboardsProvider>
                <ThemeProvider theme={themes.dark}>
                  <UpgradeContextProvider url="/upgrade" buttonText="Upgrade Now">
                    <GlobalTheme />
                    <EodDrawerProvider maApiHost={env.MAAPI_HOST} authenticatedFetch={authenticatedFetch}>
                      <Component />
                    </EodDrawerProvider>
                  </UpgradeContextProvider>
                </ThemeProvider>
              </DashboardsProvider>
            </MATIApiProvider>
          </AuthContextProvider>
        </Provider>
      </BrowserRouter>
    </MauiProvider>
  )

  AppProviders.displayName = 'AppProviders'

  return AppProviders
}
export default withProviders(App)
